
import { createApp } from "https://unpkg.com/petite-vue?module";

createApp({

	activeProductionFilters:[],
	activeCountryFilters: [],
	lang: document.getElementById('container').getAttribute("data-lang"),
	startDate: '',
	endDate: '',
	activeDateFilters:[],
	notfilteringondates:true,

	filterOnProduction(filterId,filterLabel) {
		var filter = {
			id: filterId,
			label: filterLabel
		}
		if(!this.activeProductionFilters.some(e => e.id === filterId)){
		  this.activeProductionFilters.push(filter);
		}else{
		  this.activeProductionFilters.splice(this.activeProductionFilters.findIndex(e => e.id === filterId), 1);
		}
		this.getItemsByFilter();
	},

	productionFilterIsActive(filterId,filterLabel){
		var filter = {
			id: filterId,
			label: filterLabel
		}
		if (this.activeProductionFilters.some(e => e.id === filterId)){
			return true;
		}
		return false;
	},

	allProductions(){
		this.activeProductionFilters = [];
		this.getItemsByFilter();
	},
	allProductionsActive(){
		if (this.activeProductionFilters.length == 0) {
			return true;
		}return false;
	},

	filterOnCountry(filterId,filterLabel) {
		var filter = {
			id: filterId,
			label: filterLabel
		}
		// console.log(this.activeCountryFilters)

		if (!this.activeCountryFilters.some(e => e.id === filterId)) {
		  this.activeCountryFilters.push(filter);
		}else{
		  this.activeCountryFilters.splice(this.activeCountryFilters.findIndex(e => e.id === filterId), 1);
		}
		this.getItemsByFilter();
	},

	countryFilterIsActive(filterId,filterLabel){
		var filter = {
			id: filterId,
			label: filterLabel
		}
		if (this.activeCountryFilters.some(e => e.id === filterId)){
			return true;
		}
		return false;
	},

	allCountries(){
		this.activeCountryFilters = [];
		this.getItemsByFilter();
	},
	allCountriesActive(){
		if (this.activeCountryFilters.length == 0) {
			return true;
		}return false;
	},

	renderTag(filter){
		return filter
	},
	filterIds(arr){
		var ids = [];
		for (var i = arr.length - 1; i >= 0; i--) {
			ids.push(arr[i].id)
		}
		return ids;
	},

	removeTag(){
		this.activeTagFilters = [];
		this.getItemsByFilter();
	},

	getItemsByFilter(){
		this.notfilteringondates = true;
		var URL = "/on-tour/filter?";
		if (this.lang == 'en') {
			URL = '/' + this.lang + URL;
		}

		if(this.activeProductionFilters.length != 0){
			var acids = this.filterIds(this.activeProductionFilters);
			URL += 'productions=' + acids.toString();
		}
		if(this.activeCountryFilters.length != 0){
			var ids = this.filterIds(this.activeCountryFilters);
			URL += '&countries=' + ids.toString();
		}

		// console.log(this.startDate, this.endDate);

		if(this.startDate != '' && this.startDate != undefined){
			URL += '&startdate=' + this.startDate;
			this.notfilteringondates = false;
		}
		if(this.endDate != '' && this.endDate != undefined && this.endDate != this.startDate){
			URL += '&enddate=' + this.endDate;
			this.notfilteringondates = false;
		}

    axios.get(URL)
    .then(response => {
    	var resUp = $(response.data).find('.results');
    	// console.log(resUp)
    	$('.list').html(resUp.html());
    	$("html, body").animate({ scrollTop: 0 }, "fast");
    })
	},

	filterOnDate(date) {
		if (this.activeDateFilters.some(e => e === date)) {
		  this.activeDateFilters.splice(this.activeDateFilters.findIndex(e => e === date), 1);
		  this.startDate = this.activeDateFilters[0];
		  this.endDate = this.activeDateFilters[0];
		}
		this.getItemsByFilter();
	},


	 setDates(e){
		// console.log('test',e.target.value)
		var dates = e.target.value.split('-');
		this.activeDateFilters = [];
		this.startDate = dates[0];
		this.endDate = dates[1];
		this.activeDateFilters.push(this.startDate);
		if (this.endDate != this.startDate) {
			this.activeDateFilters.push(this.endDate);
		}
		this.getItemsByFilter()
	}
}).mount()

$(document).ready(function(){
	$('.filter-btn').click(function(e){
    e.stopPropagation();
    var parent = $(this).parent();
    if(parent.hasClass('open')){
      parent.removeClass('open');
    }else{
      parent.addClass('open');
    }
  })

	// $( document ).on( "click", ".pagination a", function(e) {
  // 	e.preventDefault();
  // 	var url = $(this).attr('href') + '&tl=past';
  // 	var targetPage = $(this).attr('data-number');

	// 	axios.get(url)
	//     .then(response => {
	//       var resPast = $(response.data).find('.past-events');
  //   		$('.item-list.past').html(resPast.html());
  //   		if(targetPage == 1){
  //   			$('.item-list.coming a').show();
  //   		}else{
  //   			$('.item-list.coming a').hide();
  //   		}
  //     	$("html, body").animate({ scrollTop: 0 }, "fast");
	//     })
	// });
});
